import { booleanAttribute, Directive, ElementRef, inject, input } from '@angular/core';

import { useTruncation } from './truncation';

/**
 * Exposes whether the host element's text is cut off, for templates that cannot
 * reach `useTruncation` directly — inside an `@for`, say.
 *
 * ```html
 * <span
 *   class="truncate"
 *   sbTruncated
 *   #truncated="sbTruncated"
 *   [sbTooltip]="contractType.name"
 *   [sbTooltipDisabled]="!truncated.isTruncated()"
 *   sbTooltipNoDescription
 * >
 *   {{ contractType.name }}
 * </span>
 * ```
 *
 * `sbTooltipNoDescription` belongs on every tooltip paired this way: truncation
 * is visual only, so the element's accessible name is still the full string and
 * describing it with that same string makes a screen reader announce it twice.
 */
@Directive({
  selector: '[sbTruncated]',
  exportAs: 'sbTruncated',
})
export class TruncatedDirective {
  sbTruncated = input(true, { transform: booleanAttribute });

  isTruncated = useTruncation(inject<ElementRef<HTMLElement>>(ElementRef).nativeElement, this.sbTruncated);
}
